// Agent-version history container. It reuses the existing generated keyset
// List filtered by the selected agent; no frontend-only fan-out or alternate
// read model is introduced.

import { queryKeys } from "../../lib/queryKeys";
import { useListQuery } from "../../lib/useListQuery";
import { AgentVersionDetailDrawer } from "./AgentVersionDetailDrawer";
import { AgentVersionsView } from "./AgentVersionsView";

export interface AgentVersionsProps {
  agentId: string;
  onCloseDetail: () => void;
  onOpenDetail: (versionId: string) => void;
  selectedVersionId: string | null;
}

export function AgentVersions({
  agentId,
  onCloseDetail,
  onOpenDetail,
  selectedVersionId,
}: AgentVersionsProps) {
  const history = useListQuery("/v1/agent-versions", {
    params: { agent_id: agentId },
    queryKey: queryKeys.agentVersions.list({ agent_id: agentId }),
  });

  return (
    <AgentVersionsView
      detailDrawer={
        <AgentVersionDetailDrawer
          agentId={agentId}
          loadedVersions={history.items}
          versionId={selectedVersionId}
          onDismiss={onCloseDetail}
        />
      }
      history={history}
      onOpenDetail={onOpenDetail}
    />
  );
}
